import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class PipeCacheService<Value> {
    public cache: { [index: string]: Value } = {};
}
